import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  FETCH_LIST,
  SHOW_INFO_DIALOG,
  SET_ACTIVE_STATE,
  SHOW_WORKER_BALANCE_DIALOG,
  SHOW_REJECT_JOIN_REQUEST_DIALOG,
  SET_IS_VETERAN,
  SHOW_DEDUCTION_DEPOSIT
} from './actionTypes'
// import { getSessionList } from './selectors'
import * as services from './services'
import * as actions from './actions'
import { message } from 'antd'

export default {
  *[FETCH_LIST]({ payload }) {
    const { params } = payload
    yield actions.toggleLoading()
    const { data, total } = yield call(services.fetchList, params)
    yield put(actions.listFetched({ data, total }))
    yield actions.toggleLoading()
  },

  *[SHOW_INFO_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('WORKER_INFO_DIALOG')

    const worker = yield call(services.findById, params.id)
    yield put(actions.updated(params.id, worker))
    params.worker = worker

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[SET_ACTIVE_STATE]({ payload }) {
    const { id, isActive } = payload

    const result = yield call(services.setActiveState, id, isActive)
    yield put(actions.updated(id, result))

    message.success('设置完成')
    // setActiveState
  },
  *[SET_IS_VETERAN]({ payload }) {
    const { id, isVeteran } = payload

    const result = yield call(services.setIsVeteran, id, isVeteran)
    yield put(actions.updated(id, result))

    message.success('设置完成')
  },
  *[SHOW_WORKER_BALANCE_DIALOG]({ payload }) {
    const { params } = payload
    const { worker } = params
    const modal = createModal('CHANGE_BALANCE_DIALOG')
    yield modal.show(params)

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (!submit) {
      return yield modal.destroy()
    }

    try {
      yield call(services.changeBalance, worker._id, submit.payload)
    } catch (err) {
      yield modal.destroy()
      throw err
    }

    // update order info
    const workerData = yield call(services.findById, worker._id)
    yield put(actions.updated(worker._id, workerData))

    yield modal.hide()

    message.success('已更新')
  },
  *[SHOW_DEDUCTION_DEPOSIT]({ payload }) {
    const { params } = payload
    const { worker } = params
    const modal = createModal('DEDUCTION_DEPOSIT')
    yield modal.show(params)

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (!submit) {
      return yield modal.destroy()
    }

    try {
      yield call(services.workersDesMargin, worker._id, submit.payload)
    } catch (err) {
      yield modal.destroy()
      throw err
    }

    // update order info
    const workerData = yield call(services.findById, worker._id)
    yield put(actions.updated(worker._id, workerData))

    yield modal.hide()

    message.success('已更新')
  },
  *[SHOW_REJECT_JOIN_REQUEST_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('REJECT_JOIN_REQUEST_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  }
}
